import dataSelect from '@store/dataForSelect/reducers';

import { question_type_select } from "@Modules/Question/configs/constants";

export default dataSelect(question_type_select);
